import { Prettify } from '@/redux/hooks/type-helpers'
import { InfiniteData, UseInfiniteQueryOptions } from '@tanstack/react-query'

import { RewardEarn } from '@vrw/data/src/redux/rewardsEarn/types'

import { QueryParamsThatChangeReturnType } from '../query-type-helpers'
import useInfiniteEarnRewards from './useInfiniteEarnRewards'
import useInfiniteSpendRewards from './useInfiniteSpendRewards'
import { Reward } from '@vrw/data/src/redux/rewards/types'
import { reduce } from 'lodash/fp'
import { RewardsSort } from '@vrw/data/src/redux/types'

export const reduceToPageCount = reduce((acc, page: unknown[]) => acc + page.length, 0)

export type UseInfiniteRewardsProps<TReturn> = Prettify<
  {
    brandName?: string
    sort?: RewardsSort
    limit?: number
    isBrands?: boolean
    categories?: string[]
    enableVariantGrouping?: boolean
    enabled?: boolean
  } & Omit<UseInfiniteQueryOptions<InfiniteData<TReturn>>, QueryParamsThatChangeReturnType>
>

const useInfiniteRewards = <T extends 'earn' | 'spend'>(
  earnOrSpend: T,
  props: T extends 'earn' ? UseInfiniteRewardsProps<RewardEarn[]> : UseInfiniteRewardsProps<Reward[]>
) => {
  const infinateEarnRewards = useInfiniteEarnRewards({ ...props, enabled: earnOrSpend === 'earn' })
  const infinateSpendRewards = useInfiniteSpendRewards({ ...props, enabled: earnOrSpend === 'spend' })
  return earnOrSpend === 'earn' ? infinateEarnRewards : infinateSpendRewards
}

export default useInfiniteRewards
